import PropTypes from "prop-types";
import React, { useState } from "react";
import { FiEdit, FiTrash } from "react-icons/fi";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import DataTable from "@/components/DataTable/DataTable";
import EditParameterModal from "@/components/Modals/EditParameterModal";

const ParametersTable = ({ data, getParameters, limit, setLimit, page, setPage, total }) => {
  const [modalShow, setModalShow] = useState(false);
  const [parameterToEdit, setParameterToEdit] = useState();
  const columns = [
    {
      title: "No",
      render: (row, data, index) => <div>{index + 1}</div>,
      width: "60px",
    },
    {
      title: "System Parameter Name",
      render: (row) => row?.name,
      grow: 2,
    },
    {
      title: "System Parameter Type",
      render: (row) => row?.type,
      grow: 2,
    },
    {
      title: "Unit / Value",
      render: (row) => row?.value,
      align: "center",
    },
    {
      title: "Action",
      render: (row) => (
        <div>
          <button
            className="btn btn-edit me-1"
            onClick={() => editParameter(row)}
            disabled={row?.name === "Electricity Usage" || row?.name === "Maximum Demand"}
          >
            {" "}
            <FiEdit />{" "}
          </button>
          <button
            className="btn btn-danger"
            onClick={() => deleteParameter(row._id)}
            disabled={row?.name === "Electricity Usage" || row?.name === "Maximum Demand"}
          >
            <FiTrash />
          </button>
        </div>
      ),
      width: "150px",
      align: "center",
    },
  ];
  const editParameter = (data) => {
    setParameterToEdit(data);
    setModalShow(true);
  };

  const deleteParameter = async (parameterId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want delete this parameter?",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .delete(`${endpoint.delete_system_parameter}/${parameterId}`)
          .then(() => {
            getParameters();
            Swal.fire({
              title: "Done!",
              text: "Parameter Deleted Successfully",
              icon: "success",
              timer: 2000,
              button: false,
            });
          })
          .catch((error) =>
            Swal.fire({
              title: "",
              text: error?.response?.data?.message || "Error happened",
              icon: "error",
              timer: 2000,
              button: false,
            }),
          );
      }
    });
  };
  return (
    <div>
      <h5 className="mb-2">List of All System Parameters</h5>
      <DataTable
        columns={columns}
        dataSource={data}
        pagination={{
          pageSize: limit,
          current: page,
          total,
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          pageSizeOptions: [10, 20, 50],
          responsive: true,
        }}
        onChange={({ pageSize, current }) => {
          setLimit(pageSize);
          setPage(current);
        }}
      />
      <EditParameterModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        parameterToEdit={parameterToEdit}
        setModalShow={setModalShow}
        getParameters={getParameters}
      />
    </div>
  );
};

export default ParametersTable;

ParametersTable.propTypes = {
  data: PropTypes.array.isRequired,
  getParameters: PropTypes.func.isRequired,
  limit: PropTypes.number.isRequired,
  setLimit: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
};
